import React from "react";
import ReactDOM, { createRoot } from "react-dom/client";

import Styles from '../css/PasswordReset.module.css';
import FontStyles from '../css/Font.module.css';

import PasswordField, { IStatePasswordField, InitialStatePasswordField } from "../modules/inputFields/PasswordField"
import Footer from '../modules/Footer';
import { getPasswordResetStatus, setPassword } from "../utils/token";
import TextField, { IStateTextField, InitialStateTextField } from "../modules/inputFields/TextField";

interface IState {
    username: IStateTextField
    password: IStatePasswordField
    passwordRepeat: IStatePasswordField
    button: JSX.Element
}

class PasswordReset extends React.Component<{}, IState> {
    private errorBoxRoot!: ReactDOM.Root | undefined;
    private successBoxRoot!: ReactDOM.Root | undefined;

    private userID!: number;
    private token!: string;

    constructor(props: {}) {
        super(props);

        this.state = {
            username: InitialStateTextField,
            password: InitialStatePasswordField,
            passwordRepeat: InitialStatePasswordField,
            button: <button onClick={this.resetPassword}>Passwort zurücksetzen</button>
        }

        document.title = "Passwort zurücksetzen";

        this.userID = parseInt(window.location.search.split("&")[0].split("=")[1]);
        this.token = window.location.search.split("&")[1].split("=")[1];
    }

    componentDidMount = async () => {
        let responsePasswordResetStatus = await getPasswordResetStatus(this.userID, this.token);

        const errorBoxContainer = document.getElementById("errorBox");
        if (this.errorBoxRoot === undefined) {
            this.errorBoxRoot = createRoot(errorBoxContainer!);
        }

        if (responsePasswordResetStatus !== undefined) {
            if (typeof responsePasswordResetStatus === "string") {
                this.errorBoxRoot.render(
                    <div id={Styles.errorMessageBox}>
                        <p key="errorMessage">Der genutzte Link ist ungültig. Forder bitte einen neuen an.</p>
                    </div>
                );

                this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
            } else if (typeof responsePasswordResetStatus === "object") {
                if (responsePasswordResetStatus.requestTime.addDays(1).getTime() < new Date().getTime()) {
                    this.errorBoxRoot.render(
                        <div id={Styles.errorMessageBox}>
                            <p key="errorMessage">Der genutzte Link ist ungültig. Forder bitte einen neuen an.</p>
                        </div>
                    );

                    this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
                }
            }
        } else {
            if (this.errorBoxRoot !== undefined) {
                this.errorBoxRoot.unmount();
            }

            this.errorBoxRoot.render(
                <div id={Styles.errorMessageBox}>
                    <p key="errorMessage">Der genutzte Link ist ungültig. Forder bitte einen neuen an.</p>
                </div>
            );

            this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
        }
    }

    onKeyUp = (event: any) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.resetPassword();
        }
    }

    resetPassword = async () => {
        let username = this.state.username.value;
        let password = this.state.password.value;
        let passwordRepeat = this.state.passwordRepeat.value;

        const errorBoxContainer = document.getElementById("errorBox");
        const successBoxContainer = document.getElementById("successBox");

        if (this.errorBoxRoot !== undefined) {
            this.errorBoxRoot.unmount();
            this.errorBoxRoot = undefined;
        }

        if (this.successBoxRoot !== undefined) {
            this.successBoxRoot.unmount();
            this.successBoxRoot = undefined;
        }

        if (password.length !== 0 && passwordRepeat.length !== 0) {
            if (password === passwordRepeat) {
                let setNewPasswordResponse = await setPassword({
                    userID: this.userID,
                    token: this.token,
                    username: username,
                    password: password
                });

                if (setNewPasswordResponse !== undefined) {
                    if (setNewPasswordResponse === "SUCCESS") {
                        this.successBoxRoot = createRoot(successBoxContainer!);

                        this.successBoxRoot.render(
                            <div id={Styles.successMessageBox}>
                                <p key="successMessage">Das Passwort wurde erfolgreich zurückgesetzt.</p>
                            </div>
                        );

                        this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
                    } else if (setNewPasswordResponse === "EQUALS_PMK") {
                        this.errorBoxRoot = createRoot(errorBoxContainer!);

                        this.errorBoxRoot.render(
                            <div id={Styles.errorMessageBox}>
                                <p key="errorMessage">Das neue Passwort darf nicht mit dem Passwortverwaltungsschlüssel übereinstimmen.</p>
                            </div>
                        );
                    } else if (setNewPasswordResponse === "TOKEN_NOT_EXIST") {
                        this.errorBoxRoot = createRoot(errorBoxContainer!);

                        this.errorBoxRoot.render(
                            <div id={Styles.errorMessageBox}>
                                <p key="errorMessage">Der genutzte Link ist ungültig. Forder bitte einen neuen an.</p>
                            </div>
                        );

                        this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
                    } else if (setNewPasswordResponse === "USER_NOT_EXIST") {
                        this.errorBoxRoot = createRoot(errorBoxContainer!);

                        this.errorBoxRoot.render(
                            <div id={Styles.errorMessageBox}>
                                <p key="errorMessage">Der verwendete Benutzername gehört nicht zu diesem Link.</p>
                            </div>
                        );
                    }
                } else {
                    this.errorBoxRoot = createRoot(errorBoxContainer!);

                    this.errorBoxRoot.render(
                        <div id={Styles.errorMessageBox}>
                            <p key="errorMessage">Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</p>
                        </div>
                    );

                    this.setState({ button: <button onClick={this.toSignIn}>Zur Anmeldung</button> });
                }
            } else {
                this.errorBoxRoot = createRoot(errorBoxContainer!);

                this.errorBoxRoot.render(
                    <div id={Styles.errorMessageBox}>
                        <p key="errorMessage">Die Passwörter müssen übereinstimmen!</p>
                    </div>
                );
            }
        } else {
            this.errorBoxRoot = createRoot(errorBoxContainer!);

            this.errorBoxRoot.render(
                <div id={Styles.errorMessageBox}>
                    <p key="errorMessage">Es müssen alle Felder ausgefüllt sein!</p>
                </div>
            );
        }
    }

    toSignIn = () => {
        window.location.href = "/signIn";
    }

    render() {
        return (
            <>
                <div id={Styles.passwordReset}>
                    <div id={Styles.title}>
                        <h1><b>Web</b>Database</h1>
                        <h3 className={FontStyles.whiteColor}>Passwort zurücksetzen</h3>
                    </div>
                    <div id={Styles.input}>
                        <div id="successBox" />
                        <div id="errorBox" />

                        <h6>Benutzername</h6>
                        <TextField onKeyUp={this.onKeyUp} state={this.state.username} setState={(value: IStateTextField) => this.setState({ username: value })} />

                        <h6>Passwort</h6>
                        <PasswordField onKeyUp={this.onKeyUp} state={this.state.password} setState={(value: IStatePasswordField) => this.setState({ password: value })} />

                        <h6>Passwort wiederholen</h6>
                        <PasswordField onKeyUp={this.onKeyUp} state={this.state.passwordRepeat} setState={(value: IStatePasswordField) => this.setState({ passwordRepeat: value })} />

                        {this.state.button}
                    </div>
                </div>
                <div id={"popUp"} />
                <Footer />
            </>
        );
    }
}

export default PasswordReset;